import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Sends each role to a landing page it can actually access: management to the
 * analytics dashboard, everyone else (clients, store/production staff) to a
 * page within their permission set.
 */
export const IndexRedirect: React.FC = () => {
  const { isManagement, isClient } = useAuth();
  if (isManagement) return <Navigate to="/dashboard" replace />;
  if (isClient) return <Navigate to="/orders" replace />;
  return <Navigate to="/inventory" replace />;
};
